type ToastData = { content: { body: string; title: string }; id: string; whitelist: string[] };

const toastData: ToastData[] = [];

export default toastData;
